import React from 'react'
import { Add } from '@material-ui/icons'
import {Button} from '@material-ui/core/';

export default function AddTagButton({option, isAdd,onAddTagButton}) {
  
  return (
    <div>
      {
        isAdd? <Button variant="contained" size="small" className={'bg-success text-white'} onClick={()=>{onAddTagButton(option)}}><Add/>{option.keyword}</Button>: <div>{option.keyword}</div>
      }
    </div>
  )
}
